import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-campaign-data',
  templateUrl: './campaign-data.component.html',
  styleUrls: ['./campaign-data.component.scss']
})
export class CampaignDataComponent implements OnInit {

    @Input() campaignData: Object = {};

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/components/campaign-data/campaign-data.component.ts